
export const SurveyInvitationFileUploadErrors = ['invalid_email', 'email_in_use', 'repeated_email'] as const;
export type SurveyInvitationFileUploadError = typeof SurveyInvitationFileUploadErrors[number];

export type SurveyInvitationFileLine = {
    content:string,
    email:string,
    error:SurveyInvitationFileUploadError | null
};

export type SurveyInvitationFile =
{
    id:string,
    surveyId:string,
    lines:SurveyInvitationFileLine[]
    uploadTimestamp:Date,
    invitationsSentTimestamp:Date | null
}